const tradeHelper = {
    /**
     * Returns an array of monthly volumes related to a trade period
     * (ex.: for Q1-21, it will return Jan-21, Feb-21, and Mar-21.
     *  For Win-21: Oct-21, Nov-21, Dec-21, Jan-22, Feb-22, and Mar-22
     *  will be returned)
     * @param {any} tradePeriods - all the trade periods related to a contract/atg
     * @param {any} volumes - all the volumes related to a contract/atg
     * @param {any} periodId - Id of the trade period for which we want to get monthly volumes
     * @param {any} contractId - Id of the contract for which we want to get monthly volumes
     */
    getTradeablePeriodMonthlyVolumes: function (tradePeriods, volumes, periodId, contractId = null) {

        var self = this;
        self.vlms = volumes;
        let selectedPeriod = tradePeriods.filter(tp => { return tp.id === periodId })[0];

        let q1MonthPrefixes = ['Jan', 'Feb', 'Mar'];
        let q2MonthPrefixes = ['Apr', 'May', 'Jun'];
        let q3MonthPrefixes = ['Jul', 'Aug', 'Sep'];
        let q4MonthPrefixes = ['Oct', 'Nov', 'Dec'];
        let summerMonthPrefixes = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
        let winterCurrentYearMonthPrefixes = ['Oct', 'Nov', 'Dec']
        let winterNextYearMonthPrefixes = ['Jan', 'Feb', 'Mar']
        let calMonthPrefixes = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        
        let yearLastTwoDigits = selectedPeriod.year.toString().slice(-2);
        let nextYearLastTwoDigits = (selectedPeriod.year + 1).toString().slice(-2);
        let periodName = selectedPeriod.name.substr(0, selectedPeriod.name.indexOf('-'));
        let monthlyVolumes = [];

        if (calMonthPrefixes.includes(periodName)) {
            monthlyVolumes = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-')) === periodName && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                        v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-')) === periodName && v.year.toString().slice(-2) === yearLastTwoDigits;
                }
                return contractId ? v.name.substr(0, v.name.indexOf('-')) === periodName && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                    v.name.substr(0, v.name.indexOf('-')) === periodName && v.year.toString().slice(-2) === yearLastTwoDigits;
            });
        } else if (periodName === 'Q1') {
            monthlyVolumes = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? q1MonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                        q1MonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
                }
                return contractId ? q1MonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                    q1MonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
            });
        } else if (periodName === 'Q2') {
            monthlyVolumes = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? q2MonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                        q2MonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
                }
                return contractId ? q2MonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                    q2MonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
            });
        } else if (periodName === 'Q3') {
            monthlyVolumes = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? q3MonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                        q3MonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
                }
                return contractId ? q3MonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                    q3MonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
            });
        } else if (periodName === 'Q4') {
            monthlyVolumes = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? q4MonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                        q4MonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
                }
                return contractId ? q4MonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                    q4MonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
            });
        } else if (periodName.toLowerCase() === 'cal') {
            monthlyVolumes = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? calMonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                        calMonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
                }
                return contractId ? calMonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                    calMonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
            });
        } else if (periodName === 'Sum') {
            monthlyVolumes = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? summerMonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                        summerMonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
                }
                return contractId ? summerMonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits && v.contractId === contractId :
                    summerMonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
            });
        } else if (periodName === 'Win') {
            // Winter season starts on October of the current year and ends on the March of the next year
            let monthlyVolumesCurrYear = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? winterCurrentYearMonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits & v.contractId === contractId :
                        winterCurrentYearMonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
                }
                return contractId ? winterCurrentYearMonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits & v.contractId === contractId :
                    winterCurrentYearMonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === yearLastTwoDigits;
            });
            let monthlyVolumesNextYear = self.vlms.filter(v => {
                if (v.tradablePeriod) {
                    return contractId ? winterNextYearMonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === nextYearLastTwoDigits && v.contractId === contractId :
                        winterNextYearMonthPrefixes.includes(v.tradablePeriod.substr(0, v.tradablePeriod.indexOf('-'))) && v.year.toString().slice(-2) === nextYearLastTwoDigits;
                }
                return contractId ? winterNextYearMonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === nextYearLastTwoDigits && v.contractId === contractId :
                    winterNextYearMonthPrefixes.includes(v.name.substr(0, v.name.indexOf('-'))) && v.year.toString().slice(-2) === nextYearLastTwoDigits;
            });

            monthlyVolumes = monthlyVolumesCurrYear.concat(monthlyVolumesNextYear);
        }

        for (var mv of monthlyVolumes) {
            let sDate = this.fixDateOffset(this.getStartDateByTradePeriodSpanIdAndYear(mv.periodSpanId, mv.year));
            mv.startDate = sDate;

            let eDate = this.fixDateOffset(this.getEndDateByTradePeriodSpanIdAndYear(mv.periodSpanId, mv.year));
            mv.endDate = eDate;

            let tPeriod = tradePeriods.filter(tp => { return tp.name === mv.tradablePeriod });
            if (contractId) {
                tPeriod = tPeriod.filter(tp => tp.contractId === contractId);
            }

            if (tPeriod.length > 0) {
                mv.contractTradeablePeriodId = tPeriod[0].id;
            }
        }

        if (contractId) {
            monthlyVolumes = monthlyVolumes.filter(mv => mv.contractId === contractId);
        }

        return monthlyVolumes;
    },
    /**
     * "Temporary" solution to date offsets. The permanent solution should be to
     * store the dates in UTC format together with timezones, and then display the
     * appropriate dates on client-side based on client location. No server-side
     * modifications should be made, and on client-side - change should be applied
     * only on read operation. This should be applied as a system-wide approach.
     * @param {any} date
     */
    fixDateOffset: function (date) {
       
        if (Object.prototype.toString.call(date) !== '[object Date]') {
            date = new Date(date);
        }
        const returnDate = new Date(date.getTime());
        returnDate.setHours(returnDate.getHours() - (returnDate.getTimezoneOffset() / 60));
        return returnDate;
    },
    /**
    * Calucalates the percentage of a partial value when compared to the to the total value
    *
    * @param partialValue
    * @param totalValue
    */
    calculatePercentageFromValue: function (partialValue, totalValue) {
        return (100 * partialValue) / totalValue;
    },
    /**
     * Calucalates the value of a parcentage for a given total value
     *
     * @param totalValue
     * @param percentage
     */
    calculateValueFromPercentage: function (totalValue, percentage) {
        return (totalValue * percentage) / 100;
    },
    /**
    * Returns the start date as a Date object
    * @param tradePeriodSpanId
    * @param year
    */
    getStartDateByTradePeriodSpanIdAndYear: function (tradePeriodSpanId, year) {
        // Months (January to December) have Ids 1 to 12 respectively.
        // Javascript references the dates starting with 0 (to 11 respectively)
        // Cal trade period have no spanIds, so their value will be set to 0 
        // which correctly sets the Cal start date to January 1st
        let month = null;
        switch (tradePeriodSpanId) {
            case 13: // Q1
                // January
                month = 0;
                break;
            case 14: // Q2
                // April
                month = 3;
                break;
            case 15: // Q3
                // July 
                month = 6;
                break;
            case 16: // Q4
                // October
                month = 9;
                break;
            case 17: // Summer season (starts April 1st, ends Oct 31 same year)
                // May
                month = 3;
                break;
            case 18: // Winter season (starts October 1st, ends March 30 next year)
                // October
                month = 9
                break;
            case null: // calendar year
                // jan
                month = 0
                break;
            default:
                month = tradePeriodSpanId === 0 ? tradePeriodSpanId : tradePeriodSpanId - 1;
                break;
        }
        return this.fixDateOffset(new Date(year, month, 1));
    },
    /**
     * Returns the end date as a Date object
     * @param tradePeriodSpanId
     * @param year
     */
    getEndDateByTradePeriodSpanIdAndYear: function (tradePeriodSpanId, year) {
        // Months (January to December) have Ids 1 to 12 respectively.
        // Javascript references the dates starting with 0 (to 11 respectively).
        // Javascript dates range from 1 to 31. Passing 0 to the constructor will
        // create the last date of the previous month.
        // Cal trade period have no spanIds, so their year value will be increased by 1,
        // which will correctly set the Cal end date to December 31st
        let month = null;
        switch (tradePeriodSpanId) {
            case 13: // Q1
                // April (passing 0 to the constructor will create the last date of the previous month
                // i.e. March 31)
                month = 3;
                break;
            case 14: // Q2
                // July (passing 0 to the constructor will create the last date of the previous month
                // i.e. June 30)
                month = 6;
                break;
            case 15: // Q3
                // October (passing 0 to the constructor will create the last date of the previous month
                // i.e. September 30)
                month = 9;
                break;
            case 16: // Q4
                // January (passing 0 to the constructor will create the last date of the previous month
                // i.e. December 31 of previous year)
                month = 0;
                year = year + 1;
                break;
            case 17: // Summer season (starts April 1st, ends Sept 31 same year)
                // November (passing 0 to the constructor will create the last date of the previous month
                // i.e. September 31)
                month = 9;
                break;
            case 18: // Winter season (starts Nov 1st, ends Apr 30 next year)
                // May (passing 0 to the constructor will create the last date of the previous month
                // i.e. April 30, but it should also be the next year (year + 1))
                month = 3
                year = year + 1;
                break;
            case null: // calendar year
                // decembar
                month = 12
                break;
            default:
                month = tradePeriodSpanId;
                break;
        }
        return tradePeriodSpanId === 0 ? this.fixDateOffset(new Date(year + 1, tradePeriodSpanId, 0)) : this.fixDateOffset(new Date(year, month, 0));
    },
    dateDiff: function (first, second) {
        // Take the difference between the dates and divide by milliseconds per day.
        // Round to nearest whole number to deal with DST.
        return Math.round((second - first) / (1000 * 60 * 60 * 24)) + 1;
    },
}

export default tradeHelper;